import { Component, Inject, OnInit, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-rastreio-pedido-modal',
  templateUrl: './rastreio-pedido-modal.component.html',
  styleUrls: ['./rastreio-pedido-modal.component.scss']
})
export class RastreioPedidoModalComponent implements OnInit {
  idCupom;

  constructor(
    public dialogRef: MatDialogRef<RastreioPedidoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) {
    this.idCupom = data.idCupom;
  }

  ngOnInit() {
  }

  fechar() {
    this.dialogRef.close();
  }
}
